import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

const getHeaders = (domain, jwtToken,gUserId) => ({
  Authorization: `Bearer ${jwtToken}`,
  Domain: domain,
  gUserId: gUserId,
});

export const getQueryTypes = async (domain, jwtToken,gUserId) => {
  const res = await axios.get(`${BASE_URL}/api/QueryBuilder/types`, {
    headers: getHeaders(domain, jwtToken,gUserId)
  });
  return res.data;
};

export const getFields = async (domain, jwtToken, gUserId, queryType) => {
  const res = await axios.get(`${BASE_URL}/api/QueryBuilder/fields/${queryType}`, {
    headers: getHeaders(domain, jwtToken,gUserId)
  });
  return res.data;
};

export const executeQuery = async (domain, jwtToken, gUserId, payload) => {
  const res = await axios.post(`${BASE_URL}/api/QueryBuilder/execute`, payload, {
    headers: getHeaders(domain, jwtToken,gUserId)
  });
  return res.data;
};

export const previewQuery = async (domain, jwtToken, gUserId,payload) => {
  const res = await axios.post(`${BASE_URL}/api/QueryBuilder/preview`, payload, {
    headers: getHeaders(domain, jwtToken,gUserId)
  });
  return res.data;
};

export const saveQuery = async (domain, jwtToken, gUserId, payload) => {
  const res = await axios.post(`${BASE_URL}/api/QueryBuilder/save`, payload, {
    headers: getHeaders(domain, jwtToken,gUserId)
  });
  return res.data;
};

export const exportQuery = async (domain, jwtToken, gUserId, payload) => {
  const res = await axios.post(`${BASE_URL}/api/QueryBuilder/export`, payload, {
    headers: {
      ...getHeaders(domain, jwtToken, gUserId),
      "Content-Type": "application/json",
    },
    responseType: "blob",
  });

  return res;
};
export const getSavedQueries = async (domain, jwtToken,gUserId) => {
  const res = await axios.get(`${BASE_URL}/api/QueryBuilder/saved`, {
    headers: getHeaders(domain, jwtToken,gUserId)
  });
  return res.data;
};